import { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import { useLocale } from "../../intl";
import { casamapaPartnerVendorHubPath } from "../../constants/casamapaPartnerVendorPaths";
import {
  VENDOR_DIRECTORY_NAV_GROUPS,
  findGroupIdForSegment,
} from "../../constants/vendorDirectoryNavConfig";

export default function PartnerVendorDirectorySubnav({
  clientViewId,
  hubPathBuilder = casamapaPartnerVendorHubPath,
  variant = "staged",
  activeSegment = "",
}) {
  const { t } = useLocale();
  const hubPath = hubPathBuilder || casamapaPartnerVendorHubPath;
  const routeGroupId = useMemo(() => findGroupIdForSegment(activeSegment), [activeSegment]);
  const [focusedGroupId, setFocusedGroupId] = useState(routeGroupId);

  useEffect(() => {
    setFocusedGroupId(routeGroupId);
  }, [routeGroupId]);

  const focusedGroup =
    VENDOR_DIRECTORY_NAV_GROUPS.find((group) => group.id === focusedGroupId) ||
    VENDOR_DIRECTORY_NAV_GROUPS[0];
  const navClassName =
    variant === "compact"
      ? "partner-vendor-workspace__nav partner-vendor-workspace__nav--staged partner-vendor-workspace__nav--compact"
      : "partner-vendor-workspace__nav partner-vendor-workspace__nav--staged";

  return (
    <nav className={navClassName} aria-label={t("realEstate.casaMapa.admin.vendors.pipeline.title")}>
      <div
        className="partner-vendor-workspace__nav-stages"
        role="tablist"
        aria-label={t("realEstate.casaMapa.admin.vendors.pipeline.navStagesLabel")}
      >
        {VENDOR_DIRECTORY_NAV_GROUPS.map((group) => {
          const isFocused = focusedGroupId === group.id;
          const isCurrentRoute = routeGroupId === group.id;
          return (
            <button
              key={group.id}
              type="button"
              role="tab"
              id={`vendor-workspace-stage-${group.id}`}
              aria-selected={isFocused}
              aria-controls={`vendor-workspace-panel-${group.id}`}
              className={`partner-vendor-workspace__nav-stage${isFocused ? " is-active" : ""}${
                isCurrentRoute ? " is-current" : ""
              }`}
              onClick={() => setFocusedGroupId(group.id)}
            >
              <span className="partner-vendor-workspace__nav-stage-label">{t(group.labelKey)}</span>
              {isCurrentRoute && !isFocused ? (
                <span className="partner-vendor-workspace__nav-stage-dot" aria-hidden="true" />
              ) : null}
            </button>
          );
        })}
      </div>

      <div
        className="partner-vendor-workspace__nav-stage-panel"
        role="tabpanel"
        id={`vendor-workspace-panel-${focusedGroup.id}`}
        aria-labelledby={`vendor-workspace-stage-${focusedGroup.id}`}
      >
        {focusedGroup.items.map((item) => (
          <NavLink
            key={item.segment}
            to={hubPath(clientViewId, item.segment)}
            className={({ isActive }) =>
              `partner-vendor-workspace__nav-stage-link${isActive ? " is-active" : ""}`
            }
          >
            <span className="partner-vendor-workspace__nav-stage-link-label">{t(item.labelKey)}</span>
            {item.hintKey ? (
              <span className="partner-vendor-workspace__nav-stage-link-hint">{t(item.hintKey)}</span>
            ) : null}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
